import { Box, styled } from '@mui/material';
import { Link } from 'react-router-dom';
import color from 'src/theme/color';

export const Container = styled(Box)`
    background-color: ${color.blackRock};
    margin-top: 30px;
    border-radius: 4px;
`;
export const PRLink = styled(Link)`
    color: ${color.lightningYellow};
    display: block;
    margin-bottom: 5px;
    word-break: break-all;
    font-size: 14px;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`;

export const NoResultsText = styled('span')`
    color: ${color.white90};
`;
